import { PageOf } from "../types/misc";

interface UseDataPage<T> {
  rows: T[];
  totalPages: number;
}

/**
 * Helps to quickly and safely extract data from a paginated response.
 */
export const useDataPage = <T>(
  page: PageOf<T> | undefined
): UseDataPage<T> => ({
  rows: page?.rows ?? [],
  totalPages: page?.totalPages ?? 0,
});
